<template>
  <div>
    <div class="svincolati">
      <div
        v-show="showTitle"
        class="titolo navy--text text--lighten-2 font-hemi-head"
      >
        Svincolati
      </div>
      <div
        class="svincolati-options"
      >

          <v-row
            v-if="showButtonScartati"
            align="center"
            justify="center"
            no-gutters
          >
            <v-col cols="auto">
              <!-- v-if="_.size(scartati_ids) >0" -->
              <v-btn
                small
                color="primary"
                class="px-4 font-weight-bold white--text"
                @click="manageScartati"
              >
                <span class="scartati-person-icon mr-2" aria-hidden="true">
                  <v-icon small color="white">person</v-icon>
                </span>
                Scartati
                <v-icon small right color="white">chevron_right</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <div v-if="classicMode" class="d-flex align-center justify-center">
            <select-ruoli-classic
              v-model="selectedRuoloClassic"
              :ruoliAllowed="ruoliAllowed"
            ></select-ruoli-classic>
            <!-- info -->
            <v-icon
              v-if="showInformazioni"
              color="text"
              small
              @click="showDialogInformazioni"
              >info</v-icon
            >
          </div>
          <v-row v-else align="center" justify="center" no-gutters>
            <v-col cols="auto">
              <select-ruoli-mantra
                v-model="selectedRuoliMantra"
              ></select-ruoli-mantra>
            </v-col>
          </v-row>

          <v-row
            v-if="showStatsAndSearch"
            align="center"
            justify="space-between"
            dense
          >
            <v-col
              v-if="showStats"
              cols="auto"
              class="svincolati-actions d-flex align-center"
            >
              <!-- <v-icon x-small left>fa-align-left</v-icon> -->
              <v-btn
                v-if="anniStats.length > 0"
                x-small
                rounded
                depressed
                class="navy darken-3 navy--text text--lighten-3 py-4"
                @click="rotateAnniStats"
              >
                <transition name="roll" mode="out-in"
                  ><b :key="annoStats">{{ annoStats }}</b></transition
                >
              </v-btn>
              <v-btn
                x-small
                rounded
                depressed
                class="btnHomeAway navy darken-3 navy--text text--lighten-3 py-4"
                @click="rotateHomeAway"
              >
                <transition name="roll" mode="out-in">
                  <div :key="homeAway">
                    <div v-if="homeAway == 'home'">
                      <v-icon x-small>fa-home</v-icon>
                    </div>
                    <div v-if="homeAway == 'away'">
                      <v-icon x-small>fa-plane</v-icon>
                    </div>
                    <div v-if="homeAway == 'homeAway'">
                      <v-icon x-small>fa-home</v-icon>
                      +
                      <v-icon x-small>fa-plane</v-icon>
                    </div>
                  </div></transition
                >
              </v-btn>
              <v-menu offset-y content-class="svincolati-sort-menu-content">
                <template v-slot:activator="{ on }">
                  <v-btn
                    x-small
                    rounded
                    depressed
                    class="btnSort navy darken-3 navy--text text--lighten-3 px-2 py-4"
                    v-on="on"
                  >
                   <v-icon x-small class="mr-1">fa-sort</v-icon>
                    <span
                      v-if="currentSortOption"
                      class="sort-option-icon sort-option-icon--trigger"
                    >
                      <span
                        v-if="currentSortOption.iconType === 'img'"
                        class="sort-option-img"
                        :style="sortOptionImgStyle(currentSortOption)"
                      />
                      <span
                        v-else-if="currentSortOption.iconType === 'text'"
                        class="sort-option-text-icon"
                        >{{ currentSortOption.icon }}</span
                      >
                      <v-icon v-else x-small>{{ currentSortOption.icon }}</v-icon>
                    </span>

                  </v-btn>
                </template>
                <v-list dark dense class="svincolati-sort-menu navy darken-2">
                  <v-list-item
                    v-for="option in sortOptions"
                    :key="option.value"
                    :class="{ 'svincolati-sort-menu__item--selected': selectedSort == option.value }"
                    @click="selectedSort = option.value"
                  >
                    <v-list-item-icon class="mr-3">
                      <span
                        class="sort-option-icon"
                        :class="{
                          'sort-option-icon--selected':
                            selectedSort == option.value,
                        }"
                      >
                        <span
                          v-if="option.iconType === 'img'"
                          class="sort-option-img"
                          :style="sortOptionImgStyle(option)"
                        />
                        <span
                          v-else-if="option.iconType === 'text'"
                          class="sort-option-text-icon"
                          >{{ option.icon }}</span
                        >
                        <v-icon
                          v-else
                          small
                          :color="
                            selectedSort == option.value
                              ? 'secondary'
                              : 'navy lighten-3'
                          "
                          >{{ option.icon }}</v-icon
                        >
                      </span>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ option.text }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        v-if="selectedSort == option.value"
                        small
                        color="secondary"
                        >check</v-icon
                      >
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col>
              <v-text-field
                class="calciatori-search"
                prepend-icon="search"
                label="Nome o squadra..."
                color="navy lighten-2"
                v-model="nameFilter"
                :append-icon="nameFilter.length != 0 ? 'cancel' : ''"
                @click:append="resetFilter"
                hide-details

              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>

      <div class="svincolati-list">
        <div
          v-if="id_calciatori_svincolati.length == 0"
          class="text-center pa-10"
        >
          Nessuno svincolato in questo ruolo.<br />
          <div v-if="showButtonScartati && !includiScartati">
            PS: Clicca su "Scartati" per rivedere i calciatori che sono stati
            già scartati
          </div>
        </div>

        <div style="overflow: auto" v-else-if="ie">
          <!-- v-if="ie"-->
          <v-list two-line class="pa-0">
            <calciatore
              v-for="(id, index) in id_calciatori_svincolati"
              class="svincolati-calciatore"
              borderAsRuolo
              :showQuotazione="showQuotazione"
              :showMainStatus="showMainStatus"
              :showCuori="showCuori"
              :showButtonsScartaRiabilita="showButtonsScartaRiabilita"
              :disableSelection="disableSelection"
              :showStats="showStats"
              :small="smallCalciatori"
              ruoloRight
              :class="{
                textScuro,
                bgChiaro,
                'calciatore-visually-disabled': isVisuallyDisabled(id),
              }"
              :key="id"
              :id="id"
              :runningNumber="index + 1"
              :selected="
                hasCalciatoreSelectionAction
                  ? selectCalciatore.bind(null, id)
                  : null
              "
              :ripple="ripple || canDirectAssign"
              :scartato="scartati_ids.indexOf(id) != -1"
            ></calciatore>
          </v-list>
        </div>
        <div v-else>
          <!-- :item-size="77" is the height of .vue-recycle-scroller__item-view -->
          <RecycleScroller
            class="recycle-scroller"
            :items="id_calciatori_svincolati"
            :item-size="calciatoreItemSize"
            ref="vscroll-list"
            :class="{ 'nice-scroll': !is_mobile }"
            v-slot="{ item: id_calciatore_svincolato, index }"
          >
            <calciatore
              borderAsRuolo
              :showQuotazione="showQuotazione"
              :showMainStatus="showMainStatus"
              :showCuori="showCuori"
              :showButtonsScartaRiabilita="showButtonsScartaRiabilita"
              :disableSelection="disableSelection"
              :showStats="showStats"
              :small="smallCalciatori"
              ruoloRight
              :ripple="ripple || canDirectAssign"
              :class="{
                textScuro,
                bgChiaro,
                'calciatore-visually-disabled': isVisuallyDisabled(
                  id_calciatore_svincolato
                ),
              }"
              :id="id_calciatore_svincolato"
              :runningNumber="index + 1"
              :selected="
                hasCalciatoreSelectionAction
                  ? selectCalciatore.bind(null, id_calciatore_svincolato)
                  : null
              "
              :scartato="scartati_ids.indexOf(id_calciatore_svincolato) != -1"
            ></calciatore>
          </RecycleScroller>
        </div>
      </div>
    </div>
    <slot
      name="footer"
      :ruolo-classic="selectedRuoloClassic"
      :ruoli-mantra="selectedRuoliMantra"
    ></slot>
    <v-dialog v-model="dialogInformazioni" max-width="350">
      <v-card>
        <v-card-title class="navy white--text">
          <v-icon class="white--text" left>info</v-icon>
          Ricorda
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="white--text"
            light
            icon
            @click="dismissDialogInformazioni"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="white">
          <div
            class="pa-4"
            v-if="ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE"
          >
            PS: Se un ruolo non dovesse essere selezionabile è perchè quel ruolo
            è stato già completato da chi sta chiamando.
          </div>
          <div class="pa-4" v-else>
            PS: Se il ruolo non dovesse essere selezionabile è perchè quel ruolo
            è stato già completato da chi sta chiamando.
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "../js/db";
import Constants from "../js/constants";
import Calciatore from "./common/Calciatore";
import SelectRuoliClassic from "./common/SelectRuoliClassic";
import SelectRuoliMantra from "./common/SelectRuoliMantra";
import Vuex from "vuex";
import mixins from "../js/mixins";
import toast from "../js/toast";
import Config from "../../config-app/config";
// https://github.com/Akryum/vue-virtual-scroller
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "asta-svincolati",
  components: {
    Calciatore,
    RecycleScroller,
    SelectRuoliClassic,
    SelectRuoliMantra,
  },
  mixins: [mixins, toast],
  mounted() {
    console.log("--> AstaSvincolati ready.");
  },
  data() {
    return {
      selectedRuoloClassic: 0,
      selectedRuoliMantra: [],
      nameFilter: "",
      includiScartati: false,
      dialogInformazioni: false,
      firebase_host: Config.FIREBASE_HOST,
      selectedSort: localStorage.getItem(Constants.LS_SVINCOLATI_SORT) || "quotazione",
      // dialogAnniStats: false,
    };
  },
  props: {
    showInformazioni: {
      type: Boolean,
      default: false,
    },
    showButtonScartati: {
      type: Boolean,
      default: true,
    },
    showButtonsScartaRiabilita: {
      type: Boolean,
      default: false,
    },
    disableSelection: {
      type: Boolean,
      default: false,
    },
    showStats: {
      type: Boolean,
      default: true,
    },
    showQuotazione: {
      type: Boolean,
      default: true,
    },
    showMainStatus: {
      type: Boolean,
      default: true,
    },
    showCuori: {
      type: Boolean,
      default: true,
    },
    dialogParent: {
      type: Boolean,
      default: null,
    },
    ripple: {
      type: Boolean,
    },
    selected: {
      type: Function,
      default: null,
    },
    ruoliAllowed: {
      type: Array,
      default: function () {
        return [
          Constants.RUOLO.P,
          Constants.RUOLO.D,
          Constants.RUOLO.C,
          Constants.RUOLO.A,
        ];
      },
    },
    squadre: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // acquisti: {
    //   type: Object,
    //   default: null,
    // },
    maxQuotazione: {
      type: Number,
      default: 0,
    },
    showTitle: {
      type: Boolean,
    },
    textScuro: {
      type: Boolean,
    },
    bgChiaro: {
      type: Boolean,
    },
    smallCalciatori: {
      type: Boolean,
      default: true,
    },
    pickerMode: {
      type: Boolean,
      default: false,
    },
    forceClassic: {
      type: Boolean,
      default: false,
    },
    visuallyDisabledCalciatoriIds: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    // id_calciatori_svincolati: {
    //   handler(val) {
    //     console.log("id_calciatori_svincolati", val);
    //   },
    //   immediate: true,
    // },
    ruoliAllowed: {
      handler() {
        this.syncSelectedRuoloClassic();
      },
      immediate: true,
    },
    mantra: {
      // lo uso per inizializzare i ruoli selezionati
      handler() {
        this.syncSelectedRuoloClassic();
      },
      immediate: true,
    },
    forceClassic() {
      this.syncSelectedRuoloClassic();
    },
    selectedRuoloClassic() {
      this.$nextTick(this.normalizeSelectedSort);
    },
    selectedSort(value) {
      localStorage.setItem(Constants.LS_SVINCOLATI_SORT, value);
    },
    dialogParent(val) {
      // quando si chiude la dialog parent
      if (val == false) {
        this.resetFilter();
      }
    },
  },

  destroyed() {
    console.log("<-- AstaSvincolati destroyed.");
  },
  methods: {
    syncSelectedRuoloClassic() {
      if (this.classicMode) {
        this.selectedRuoloClassic =
          this.ruoliAllowed.length > 0 ? this.ruoliAllowed[0] : -1;
        this.selectedRuoliMantra = []; // serve solo se un gg prevedo di cambiare tipo_ruoli in realtime
      } else {
        this.selectedRuoloClassic = 0;
      }
    },
    manageScartati() {
      db.emit("manageScartati");
    },
    rotateAnniStats() {
      let annoStatsNext;

      // Find the index of annoStats in the array
      const currentIndex = this.anniStats.indexOf(this.annoStats);

      // If annoStats is not found or it's the last element
      if (currentIndex === -1 || currentIndex === this.anniStats.length - 1) {
        // Return the first element of the array
        annoStatsNext = this.anniStats[0];
      } else {
        // Return the next element
        annoStatsNext = this.anniStats[currentIndex + 1];
      }

      this.$store
        .dispatch("setAnnoStats", annoStatsNext)
        .then(localStorage.setItem(Constants.LS_ANNO_STATS, annoStatsNext));
    },
    rotateHomeAway() {
      let homeAwayNext;

      // Find the index of annoStats in the array
      const currentIndex = Constants.HOME_AWAY_ARY.indexOf(this.homeAway);

      // If not found or it's the last element
      if (
        currentIndex === -1 ||
        currentIndex === Constants.HOME_AWAY_ARY.length - 1
      ) {
        // Return the first element of the array
        homeAwayNext = Constants.HOME_AWAY_ARY[0];
      } else {
        // Return the next element
        homeAwayNext = Constants.HOME_AWAY_ARY[currentIndex + 1];
      }

      this.$store
        .dispatch("setHomeAway", homeAwayNext)
        .then(localStorage.setItem(Constants.LS_HOME_AWAY, homeAwayNext));
    },
    // setAnnoStats(value) {
    //   this.$store.dispatch("setAnnoStats", value);
    //   localStorage.setItem(Constants.LS_ANNO_STATS, value);
    //   this.dismissDialogAnniStats();
    // },
    showDialogInformazioni() {
      this.dialogInformazioni = true;
    },
    dismissDialogInformazioni() {
      this.dialogInformazioni = false;
    },
    // showDialogAnniStats() {
    //   this.dialogAnniStats = true;
    // },
    // dismissDialogAnniStats() {
    //   this.dialogAnniStats = false;
    // },
    resetFilter() {
      this.nameFilter = "";
    },
    isVisuallyDisabled(id) {
      return this.visuallyDisabledCalciatoriIds.includes(id);
    },
    selectCalciatore(id) {
      if (this.disableSelection) return;

      if (this.pickerMode) {
        this.selected(id);
        return;
      }

      if (this.is_calciatore_in_asta) {
        this.errorToast(
          "Sembra esserci già un calciatore all'asta",
          "Annulla prima la selezione corrente"
        );
        return;
      }

      if (this.canDirectAssign) {
        db.setCalciatoreInAsta(id)
          .then(() => {
            this.astaLogCalciatoreInAsta(id, this.user_uid);
            if (this.is_mobile) {
              db.emit("closeSvincolati");
            }
          })
          .catch(() => {
            this.errorToast("Errore", "Impossibile selezionare il calciatore");
          });
        return;
      }
      this.selected(id);
    },
    primoSvincolato() {
      return _.head(
        this.sortIds(
          this.svincolati(
            this.selectedRuoloClassic,
            "",
            this.maxQuotazione,
            false,
            this.squadre,
            []
          )
        )
      );
    },
    calciatoreStats(calciatore) {
      return calciatore &&
        calciatore.stats &&
        calciatore.stats[this.annoStats] &&
        calciatore.stats[this.annoStats][this.homeAway]
        ? calciatore.stats[this.annoStats][this.homeAway]
        : {};
    },
    numericValue(value, defaultValue = 0) {
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? defaultValue : parsed;
    },
    sortOptionImgStyle(option) {
      const src =
        option && option.icon
          ? `${this.firebase_host}/static/img/${option.icon}`
          : "";
      return {
        maskImage: `url(${src})`,
        WebkitMaskImage: `url(${src})`,
      };
    },
    normalizeSelectedSort() {
      if (this.sortOptions.some((option) => option.value === this.selectedSort)) {
        return;
      }

      const similarSortByRole = {
        golSu: "gol",
        gol: "golSu",
        rigPa: "rigori",
        rigori: "rigPa",
        pi: "ass",
        ass: "pi",
      };
      const similarSort = similarSortByRole[this.selectedSort];

      this.selectedSort = this.sortOptions.some(
        (option) => option.value === similarSort
      )
        ? similarSort
        : "quotazione";
    },
    sortValue(id, option) {
      const calciatore = this.calciatori[id] || {};
      const stats = this.calciatoreStats(calciatore);

      if (option.type === "field") {
        return calciatore[option.field] || "";
      }

      if (option.type === "quotazione") {
        return this.numericValue(calciatore.quotazione);
      }

      if (option.type === "cuori") {
        return this.cuoriCalciatore(id);
      }

      if (option.type === "stat") {
        if (option.value === "gol") {
          return (
            this.numericValue(stats.golFa) + this.numericValue(stats.rigFa)
          );
        }
        if (option.value === "rigori") {
          return this.numericValue(stats.rigFa);
        }
        if (option.value === "cartellini") {
          return this.numericValue(stats.amm) + this.numericValue(stats.esp);
        }
        return this.numericValue(stats[option.value]);
      }

      return "";
    },
    sortIds(ids) {
      const option = this.currentSortOption;

      if (!option) {
        return ids;
      }

      return _.orderBy(
        ids,
        [
          (id) => this.sortValue(id, option),
          (id) => this.numericValue((this.calciatori[id] || {}).quotazione),
          (id) => (this.calciatori[id] || {}).calciatore || "",
        ],
        [option.order, "desc", "asc"]
      );
    },
  },
  computed: {
    classicMode() {
      return this.forceClassic || this.classic;
    },
    calciatoreItemSize() {
      if (this.smallCalciatori) {
        return this.showStats ? 84 : 62;
      }

      return this.showStats ? 105 : 65;
    },
    canDirectAssign() {
      return (
        !this.disableSelection &&
        !this.pickerMode &&
        this.mode_assegna &&
        this.admin
      );
    },
    hasCalciatoreSelectionAction() {
      return !this.disableSelection && (this.pickerMode || this.canDirectAssign || Boolean(this.selected));
    },
    ruolo_da_chiamare() {
      return this.asta_settings.ruolo_da_chiamare;
    },
    id_calciatori_svincolati() {
      return this.sortIds(this.svincolati(
        this.selectedRuoloClassic,
        this.nameFilter,
        this.maxQuotazione,
        this.includiScartati,
        this.squadre,
        this.selectedRuoliMantra
      ));
    },
    showStatsAndSearch() {
      return (
        this.id_calciatori_svincolati.length > 0 || this.nameFilter.length > 0
      );
    },
    currentSortOption() {
      return this.sortOptions.find((option) => option.value === this.selectedSort);
    },
    selectedSortIcon() {
      return this.currentSortOption ? this.currentSortOption.icon : "sort";
    },
    sortOptions() {
      const commonOptions = [
        {
          text: "Quotazione",
          shortText: "Q",
          value: "quotazione",
          type: "quotazione",
          order: "desc",
          icon: "Q",
          iconType: "text",
        },
        {
          text: "Cuori",
          shortText: "Cuori",
          value: "cuori",
          type: "cuori",
          order: "desc",
          icon: "favorite",
        },
        {
          text: "Nome calciatore",
          shortText: "Nome",
          value: "nome",
          type: "field",
          field: "calciatore",
          order: "asc",
          icon: "sort_by_alpha",
        },
        {
          text: "Squadra di club",
          shortText: "Club",
          value: "club",
          type: "field",
          field: "nomeClub",
          order: "asc",
          icon: "shield",
        },
        {
          text: "Presenze",
          shortText: "Pres.",
          value: "presenze",
          type: "stat",
          order: "desc",
          icon: "fa-user",
        },
      ];
      const roleStats =
        this.selectedRuoloClassic === Constants.RUOLO.P
          ? [
              {
                text: "Gol subiti",
                shortText: "GS",
                value: "golSu",
                type: "stat",
                order: "asc",
                icon: "fa-futbol-o",
              },
              {
                text: "Rigori parati",
                shortText: "RP",
                value: "rigPa",
                type: "stat",
                order: "desc",
                icon: "rigPa.png",
                iconType: "img",
              },
              {
                text: "PI",
                shortText: "PI",
                value: "pi",
                type: "stat",
                order: "desc",
                icon: "fa-star",
              },
            ]
          : [
              {
                text: "Gol fatti",
                shortText: "Gol",
                value: "gol",
                type: "stat",
                order: "desc",
                icon: "fa-futbol-o",
              },
              {
                text: "Rigori",
                shortText: "Rig.",
                value: "rigori",
                type: "stat",
                order: "desc",
                icon: "rig.png",
                iconType: "img",
              },
              {
                text: "Assist",
                shortText: "Ass.",
                value: "ass",
                type: "stat",
                order: "desc",
                icon: "assist.png",
                iconType: "img",
              },
            ];
      return [
        ...commonOptions,
        ...roleStats,
        {
          text: "Cartellini",
          shortText: "Cart.",
          value: "cartellini",
          type: "stat",
          order: "desc",
          icon: "cartellini.png",
          iconType: "img",
        },
        {
          text: "Media voto",
          shortText: "MV",
          value: "mv",
          type: "stat",
          order: "desc",
          icon: "MV",
          iconType: "text",
        },
        {
          text: "Fantamedia",
          shortText: "FM",
          value: "fm",
          type: "stat",
          order: "desc",
          icon: "FM",
          iconType: "text",
        },
      ];
    },
    ...Vuex.mapGetters([
      "svincolati",
      "calciatori",
      "scartati_ids",
      "annoStats",
      "anniStats",
      "homeAway",
      "is_mobile",
      "cuoriCalciatore",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";
.svincolati {
  .scartati-person-icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex: 0 0 18px;

    &::after {
      content: "";
      position: absolute;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background-color: white;
      box-shadow: 0 0 0 1px var(--v-primary-base);
      transform: rotate(-45deg);
    }
  }

  .svincolati-options {
    padding: 5px 10px 5px 10px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // height: 132px; // importante, vedi hack height in main.scss

    .calciatori-search {
      margin: 0;
      padding: 0;
    }
    .v-input__slot {
      justify-content: center;
    }
  }

  .btnHomeAway {
    min-width: 52px;
  }
  .svincolati-actions {
    gap: 4px;
  }
  .btnSort {
    min-width: 28px;
  }
  .sort-option-icon--trigger {
    align-items: center;
    color: var(--v-navy-lighten3);
    display: inline-flex;
    height: 14px;
    justify-content: center;
    width: 14px;
  }
  .sort-option-icon--trigger .sort-option-img {
    background-color: var(--v-navy-lighten3);
    display: inline-block;
    height: 13px;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    width: 13px;
  }
  .roll-enter-active,
  .roll-leave-active {
    transition: all 0.1s;
  }

  .roll-enter {
    transform: translateY(50%);
    opacity: 0;
  }

  .roll-leave-to {
    transform: translateY(-50%);
    opacity: 0;
  }
  // .svincolati-list .recycle-scroller {
  //   // vale per la dialog
  //   height: 400px; // importante: deve essere specificato altrimenti reycler-scroller non funzionerà
  //   // e serve anche per far scrollare solo la lista invece che tutta la dialog
  // }
}
</style>


<style lang="scss">


.calciatore-visually-disabled {
  opacity: 0.42;
}

.svincolati {

  .calciatore-sx .imgCalciatore {
    height: 58px;
    width: 58px;
  }

  .calciatore.small .calciatore-sx .imgCalciatore {
    height: 52px;
    width: 52px;
    margin: 0px 0 0px 20px;
  }

  .imgCalciatore .imgContainer .img:not(.flag) {
    width: 85%;
  }
}


.svincolati-sort-menu-content {
  .svincolati-sort-menu {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 4px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.32);
    min-width: 190px;
    padding: 4px 0;
  }

  .svincolati-sort-menu .v-list-item__icon {
    min-width: 24px;
  }

  .sort-option-icon {
    align-items: center;
    color: var(--v-navy-lighten3);
    display: inline-flex;
    height: 18px;
    justify-content: center;
    width: 18px;
  }

  .sort-option-img {
    background-color: var(--v-navy-lighten3);
    display: inline-block;
    height: 19px;
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: contain;
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    width: 19px;
  }

  .sort-option-text-icon {
    color: currentColor;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
  }

  .sort-option-icon--selected {
    color: var(--v-secondary-base);
  }

  .sort-option-icon--selected .sort-option-text-icon {
    color: var(--v-secondary-base);
  }

  .sort-option-icon--selected .sort-option-img {
    background-color: var(--v-secondary-base);
    filter: drop-shadow(0 0 3px var(--v-secondary-base));
  }

  .svincolati-sort-menu__item--selected {
    background: color-mix(in srgb, var(--v-secondary-base), transparent 82%);
    border-left: 3px solid var(--v-secondary-base);
  }

  .svincolati-sort-menu__item--selected .v-list-item__title {
    color: var(--v-secondary-base);
    font-weight: 700;
  }
}
</style>
